import React from 'react';
import { takeLatest, put, select, call } from 'redux-saga/effects';
import {
    GET_ACTIVE_SERVICES_REQUEST,
    getActiveServicesSuccess,
    getActiveServicesFailure,
    GET_GPS_SUMMARY_REQUEST,
    getGpsSummarySuccess,
    getGpsSummaryFailure,
    GET_GPS_REPORT_REQUEST,
    getGpsReportSuccess,
    getGpsReportFailure,
    GET_GPS_SUBSTATUS_TABLE_REPORT_REQUEST,
    getGpsSubstatusTableReportSuccess,
    getGpsSubstatusTableReportFailure,
    GET_TICKETS_SUMMARY_REQUEST,
    getTicketsSummarySuccess,
    getTicketsSummaryFailure,
    GET_TICKETS_SUMMARY_GRAPH_REQUEST,
    getTicketsSummaryGraphSuccess,
    getTicketsSummaryGraphFailure,
    GET_SIMCARDS_REPORT_REQUEST,
    getSimcardsReportSuccess,
    getSimcardsReportFailure,
    GET_SIMCARDS_REPORT_FILTERED_REQUEST,
    getSimcardsReportFilteredSuccess,
    getSimcardsReportFilteredFailure,
    GET_DEVICES_REPORT_REQUEST,
    getDevicesReportSuccess,
    getDevicesReportFailure,
    GET_DEVICES_REPORT_FILTERED_REQUEST,
    getDevicesReportFilteredSuccess,
    getDevicesReportFilteredFailure,
    GET_AGENCIES_REQUEST,
    getAgenciesSuccess,
    getAgenciesFailure,
    GET_COMPANIES_REPORTS_REQUEST,
    getCompaniesReportsSuccess,
    getCompaniesReportsFailure,
    EXPORT_GPS_SUMMARY_REQUEST,
    exportGpsSummarySuccess,
    exportGpsSummaryFailure,
    EXPORT_TICKETS_SUMMARY_REQUEST,
    exportTicketsSummarySuccess,
    exportTicketsSummaryFailure,
    EXPORT_GPS_REPORT_REQUEST,
    exportGpsReportSuccess,
    exportGpsReportFailure,
    EXPORT_SIMCARDS_REPORT_REQUEST,
    exportSimcardsReportSuccess,
    exportSimcardsReportFailure,
    EXPORT_DEVICES_REPORT_REQUEST,
    exportDevicesReportSuccess,
    exportDevicesReportFailure,
    EXPORT_INVENTORY_REPORT_REQUEST,
    exportInventoryReportSuccess,
    exportInventoryReportFailure,
    GET_USER_SETTINGS_REQUEST,
    getUserSettingsSuccess,
    getUserSettingsFailure,
    SAVE_USER_SETTINGS_REQUEST,
    saveUserSettingsSuccess,
    saveUserSettingsFailure
} from '../actions/reports';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import {
    getActiveServices,
    getGpsSummary,
    getGpsReport,
    getTicketsSummary,
    getSimcardsReport,
    getDevicesReport,
    getAgencies,
    getCompaniesReports,
    exportGpsSummary,
    exportTicketsSummary,
    exportGpsReport,
    exportSimcardsReport,
    exportDevicesReport,
    exportInventoryReport
} from '../services/reportsServices';
import {
    getUserSettings,
    saveUserSettings
} from '../services/userSettingsServices';
import styles from '../../shared/styles/notifications.module.scss';
import { toast } from 'react-toastify';
import SVG from 'react-inlinesvg';
import { checkCircleSVG } from '../../shared/helpers/icons';

const getActiveServicesWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getActiveServices, filters, token);
        const {
            data: { activeservices, total } 
        } = response;
        yield put(getActiveServicesSuccess(activeservices, total));
    } catch (err) {
        yield put(getActiveServicesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getGpsSummaryWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getGpsSummary, filters, token);
        const { data } = response;
        yield put(getGpsSummarySuccess(data));
    } catch (err) {
        yield put(getGpsSummaryFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getGpsReportWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getGpsReport, filters, token);
        const { data } = response;
        yield put(getGpsReportSuccess(data));
    } catch (err) {
        yield put(getGpsReportFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getGpsSubstatusTableReportWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getGpsReport, filters, token);
        const { data } = response;
        yield put(getGpsSubstatusTableReportSuccess(data));
    } catch (err) {
        yield put(getGpsSubstatusTableReportFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getTicketsSummaryWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getTicketsSummary, filters, token);
        const { data } = response;
        yield put(getTicketsSummarySuccess(data));
    } catch (err) {
        yield put(getTicketsSummaryFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getTicketsSummaryGraphWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getTicketsSummary, filters, token);
        const { data } = response;
        yield put(getTicketsSummaryGraphSuccess(data));
    } catch (err) {
        yield put(getTicketsSummaryGraphFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getSimcardsReportWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getSimcardsReport, filters, token);
        const { data } = response;
        yield put(getSimcardsReportSuccess(data));
    } catch (err) {
        yield put(getSimcardsReportFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getSimcardsReportFilteredWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getSimcardsReport, filters, token);
        const { data } = response;
        yield put(getSimcardsReportFilteredSuccess(data));
    } catch (err) {
        yield put(getSimcardsReportFilteredFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getDevicesReportWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getDevicesReport, filters, token);
        const { data } = response;
        yield put(getDevicesReportSuccess(data));
    } catch (err) {
        yield put(getDevicesReportFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getDevicesReportFilteredWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getDevicesReport, filters, token);
        const { data } = response;
        yield put(getDevicesReportFilteredSuccess(data));
    } catch (err) {
        yield put(getDevicesReportFilteredFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getAgenciesWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getAgencies, filters, token);
        const { data } = response;
        yield put(getAgenciesSuccess(data));
    } catch (err) {
        yield put(getAgenciesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getCompaniesReportsWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getCompaniesReports, filters, token);
        const { data } = response;
        yield put(getCompaniesReportsSuccess(data));
    } catch (err) {
        yield put(getCompaniesReportsFailure(err));
        yield put(showGlobalError(true, err));
    }
};

// Helper function to download blob files
const downloadFile = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

const exportGpsSummaryWorker = function* ({ payload: { filters, format } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(exportGpsSummary, filters, format, token);
        const filename = `gps_summary.${format === 'excel' ? 'xlsx' : 'pdf'}`;
        downloadFile(response.data, filename);
        yield put(exportGpsSummarySuccess());
        yield put(showGlobalError(true, 200, 'exported'));
    } catch (err) {
        yield put(exportGpsSummaryFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const exportTicketsSummaryWorker = function* ({ payload: { filters, format } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(exportTicketsSummary, filters, format, token);
        const filename = `tickets_summary.${format === 'excel' ? 'xlsx' : 'pdf'}`;
        downloadFile(response.data, filename);
        yield put(exportTicketsSummarySuccess());
        yield put(showGlobalError(true, 200, 'exported'));
    } catch (err) {
        yield put(exportTicketsSummaryFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const exportGpsReportWorker = function* ({ payload: { filters, format } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(exportGpsReport, filters, format, token);
        const filename = `gps_report.${format === 'excel' ? 'xlsx' : 'pdf'}`;
        downloadFile(response.data, filename);
        yield put(exportGpsReportSuccess());
        yield put(showGlobalError(true, 200, 'exported'));
    } catch (err) {
        yield put(exportGpsReportFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const exportSimcardsReportWorker = function* ({ payload: { filters, format } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(exportSimcardsReport, filters, format, token);
        const filename = `simcards_report.${format === 'excel' ? 'xlsx' : 'pdf'}`;
        downloadFile(response.data, filename);
        yield put(exportSimcardsReportSuccess());
        yield put(showGlobalError(true, 200, 'exported'));
    } catch (err) {
        yield put(exportSimcardsReportFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const exportDevicesReportWorker = function* ({ payload: { filters, format } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(exportDevicesReport, filters, format, token);
        const filename = `devices_report.${format === 'excel' ? 'xlsx' : 'pdf'}`;
        downloadFile(response.data, filename);
        yield put(exportDevicesReportSuccess());
        yield put(showGlobalError(true, 200, 'exported'));
    } catch (err) {
        yield put(exportDevicesReportFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const exportInventoryReportWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(exportInventoryReport, filters, token);
        const timestamp = new Date().toISOString().split('T')[0];
        const filename = `inventario_completo_${timestamp}.xlsx`;
        downloadFile(response.data, filename);
        yield put(exportInventoryReportSuccess());
        
        toast.success(
            <div className={styles.customToastSuccess}>
                <div className={styles.toastContent}>
                    <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                    Archivo exportado con éxito
                </div>
            </div>,
            {
                className: styles.toast,
                toastId: `inventory-exported-${Date.now()}`
            }
        );
    } catch (err) {
        yield put(exportInventoryReportFailure(err));
        yield put(showGlobalError(true, err));
    }
};

// User Settings (saved filters) - failures are silent, this is a background convenience feature
const getUserSettingsWorker = function* ({ payload: { userId, screen } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getUserSettings, userId, screen, token);
        const { data } = response;
        yield put(getUserSettingsSuccess(screen, data?.filters || null));
    } catch (err) {
        yield put(getUserSettingsFailure(screen, err));
    }
};

const saveUserSettingsWorker = function* ({ payload: { userId, screen, filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        yield call(saveUserSettings, userId, screen, filters, token);
        yield put(saveUserSettingsSuccess(screen, filters));
    } catch (err) {
        yield put(saveUserSettingsFailure(screen, err));
    }
};

export default [
    takeLatest(GET_ACTIVE_SERVICES_REQUEST, getActiveServicesWorker),
    takeLatest(GET_GPS_SUMMARY_REQUEST, getGpsSummaryWorker),
    takeLatest(GET_GPS_REPORT_REQUEST, getGpsReportWorker),
    takeLatest(GET_GPS_SUBSTATUS_TABLE_REPORT_REQUEST, getGpsSubstatusTableReportWorker),
    takeLatest(GET_TICKETS_SUMMARY_REQUEST, getTicketsSummaryWorker),
    takeLatest(GET_TICKETS_SUMMARY_GRAPH_REQUEST, getTicketsSummaryGraphWorker),
    takeLatest(GET_SIMCARDS_REPORT_REQUEST, getSimcardsReportWorker),
    takeLatest(GET_SIMCARDS_REPORT_FILTERED_REQUEST, getSimcardsReportFilteredWorker),
    takeLatest(GET_DEVICES_REPORT_REQUEST, getDevicesReportWorker),
    takeLatest(GET_DEVICES_REPORT_FILTERED_REQUEST, getDevicesReportFilteredWorker),
    takeLatest(GET_AGENCIES_REQUEST, getAgenciesWorker),
    takeLatest(GET_COMPANIES_REPORTS_REQUEST, getCompaniesReportsWorker),
    takeLatest(EXPORT_GPS_SUMMARY_REQUEST, exportGpsSummaryWorker),
    takeLatest(EXPORT_TICKETS_SUMMARY_REQUEST, exportTicketsSummaryWorker),
    takeLatest(EXPORT_GPS_REPORT_REQUEST, exportGpsReportWorker),
    takeLatest(EXPORT_SIMCARDS_REPORT_REQUEST, exportSimcardsReportWorker),
    takeLatest(EXPORT_DEVICES_REPORT_REQUEST, exportDevicesReportWorker),
    takeLatest(EXPORT_INVENTORY_REPORT_REQUEST, exportInventoryReportWorker),
    takeLatest(GET_USER_SETTINGS_REQUEST, getUserSettingsWorker),
    takeLatest(SAVE_USER_SETTINGS_REQUEST, saveUserSettingsWorker)
];
